<script setup lang="ts">
  const props = defineProps<{
    steps: string[];
    current: number;
  }>();

  const isCurrent = (index: number) => props.current === index;
  const isFinished = (index: number) => props.current > index;
</script>

<template>
  <div class="store-steps">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="step"
      :current="isCurrent(index)"
      :finished="isFinished(index)">
      <div class="circle-wrapper">
        <div class="circle">
          <icon-girassol:check
            v-if="isFinished(index)"
            alt="check"
            class="text-neutral-high-pure icon-size-medium" />
          <div v-else class="pointer" />
        </div>
        <span class="label">{{ step }}</span>
      </div>
      <div class="connection" />
    </div>
  </div>
</template>

<style lang="scss">
  .store-steps {
    @apply flex items-center justify-between;
    @apply w-[422px] px-2xs;

    > .step {
      @apply flex-1 flex;

      > .circle-wrapper {
        @apply flex flex-col items-center;
        @apply w-xs;

        > .circle {
          @apply flex items-center justify-center;
          @apply w-xs h-xs rounded-full;
          @apply bg-neutral-high-pure;
          @apply border-1 border-neutral-low-light;

          > .pointer {
            @apply w-4xs h-4xs rounded-full;
          }
        }
      }

      > .connection {
        @apply flex-1;
        @apply relative top-4xs;
        @apply h-[1px];
        @apply bg-neutral-low-light;
      }

      &:last-child {
        @apply flex-none;

        > .connection {
          @apply hidden;
        }
      }

      &[finished='true'] {
        > .circle-wrapper {
          > .circle {
            @apply bg-brand-secondary-pure;
            @apply border-1 border-brand-secondary-pure;

            > img {
              @apply icon-size-medium;
            }
          }
        }

        > .connection {
          @apply h-[2px];
          @apply bg-brand-secondary-pure;
        }
      }

      &[current='true'] {
        > .circle-wrapper {
          > .circle > .pointer {
            @apply bg-brand-secondary-pure;
          }
        }
      }
    }
  }
</style>
